module.exports = __webpack_public_path__ + "media/assets_v3/images/cs-go-6027308320f2917d60bdcd70135340e9.png";